<template>
    <td :class="className" v-bind="{'scoped': scopedRow}" :style="{ 'background-color': color, 'color': fontColor }"><span :style="{ 'background-color': color }"></span> {{ text }} </td>
</template>

<script>
const CLASS_HEADER = "mds-data-table__cell row-header";
const CLASS_DATA = "mds-data-table__cell false mds-data-table__cell--right";

export default {
    props: {
        dataCell: {
            type: Object,
            required: true
        },
        isScoped: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        className () {
            return this.isScoped ? CLASS_HEADER : CLASS_DATA;
        },
        text () {
            return this.dataCell.text;
        },
        scopedRow () {
            return this.isScoped ? "row" : false;
        },
        color () {
            return this.dataCell.color && this.dataCell.color.trim() !== "" ? this.dataCell.color : "transparent";
        },
        fontColor () {
            return this.dataCell.fontColor && this.dataCell.fontColor.trim() !== "" ? this.dataCell.fontColor : "#5E5E5E";
        }
    }
};
</script>

<style lang="scss" scoped>
.mds-data-table__cell {
    &.row-header {
        background-color: transparent !important;
        padding-left: 15px;

        span {
            display: inline-block;
        }
    }
    span {
        display: none;
        left: 0;
        height: 8px;
        position: absolute;
        top: 10px;
        width: 8px;
    }
}
.mds-data-table__cell--right:last-child {
    padding-right: $mds-space-1-x;
}
</style>


// WEBPACK FOOTER //
// src/components/TableDataCell.vue